import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";

export function PrivateRoute({ children }) {
  const { token, } = useSelector((state) => state.user);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  if (!token) {
    return <Navigate to="/" replace={true} />;
  }

  window.addEventListener('error', e => {
    // prompt user to confirm refresh
    if (/Loading chunk [\d]+ failed/.test(e.message)) {
      window.location.reload();
    }
  });

  return children;
}

export default PrivateRoute;
